import { useEffect, useState } from 'react';

interface Particle {
  id: number;
  x: number;
  y: number;
  size: number;
  opacity: number;
  speed: number;
  direction: number;
}

export default function ParticleEffect() {
  const [particles, setParticles] = useState<Particle[]>([]);

  useEffect(() => {
    const createParticles = () => {
      const newParticles: Particle[] = [];
      for (let i = 0; i < 50; i++) {
        newParticles.push({
          id: i,
          x: Math.random() * window.innerWidth,
          y: Math.random() * window.innerHeight,
          size: Math.random() * 3 + 1,
          opacity: Math.random() * 0.5 + 0.1,
          speed: Math.random() * 0.5 + 0.1,
          direction: Math.random() * Math.PI * 2,
        });
      }
      setParticles(newParticles);
    };

    createParticles();

    const animateParticles = () => {
      setParticles(prev =>
        prev.map(particle => {
          // calculate next position
          const nextX =
            particle.x + Math.cos(particle.direction) * particle.speed;
          const nextY =
            particle.y + Math.sin(particle.direction) * particle.speed;

          // wrap around the screen edges
          const wrappedX =
            nextX > window.innerWidth
              ? 0
              : nextX < 0
              ? window.innerWidth
              : nextX;
          const wrappedY =
            nextY > window.innerHeight
              ? 0
              : nextY < 0
              ? window.innerHeight
              : nextY;

          return {
            ...particle,
            x: wrappedX,
            y: wrappedY,
          };
        })
      );
    };

    const interval = setInterval(animateParticles, 50);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none z-0">
      {particles.map(particle => (
        <div
          key={particle.id}
          className="absolute rounded-full bg-violet-400"
          style={{
            left: `${particle.x}px`,
            top: `${particle.y}px`,
            width: `${particle.size}px`,
            height: `${particle.size}px`,
            opacity: particle.opacity,
            boxShadow: `0 0 ${particle.size * 2}px rgba(139, 92, 246, 0.3)`,
          }}
        />
      ))}
    </div>
  );
}